export default __webpack_public_path__ + "static/media/store-1.0591705a.jpg";